(function () {
  var roots = document.querySelectorAll('[data-hmg]');
  Array.prototype.forEach.call(roots, function (root) {
    var cfgEl = root.querySelector('[data-hmg-config]');
    if (!cfgEl) return;
    var CFG = {};
    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var SWITCH_TEXT = CFG.switch || {};
    var GUARD = CFG.guard || {};
    var TITLES = CFG.titles || {};

    var state = { age: '', concern: '', usage: '', freezer: '' };
    var history = [];
    var lastResult = null;
    var sessionId = 'hmg_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);

    function param(name) {
      return new URLSearchParams(window.location.search).get(name) || '';
    }

    var pUse = param('use');
    var pConcern = param('concern');
    if (pUse === 'topping') state.usage = 'add';
    if (pUse === 'main') state.usage = 'main';
    if (pUse === 'homemade') { state.usage = 'main'; state.concern = 'homemade'; }
    if (pConcern) state.concern = pConcern;

    var STEP_ORDER = ['age', 'concern', 'usage', 'freezer'];

    function isStepNeeded(name) {
      if (name === 'age') return true;
      if (name === 'concern') return !state.concern;
      if (name === 'usage') return !state.usage;
      if (name === 'freezer') return state.concern === 'homemade' && state.usage !== 'consult' && !state.freezer;
      return false;
    }

    function neededSteps() {
      return STEP_ORDER.filter(isStepNeeded);
    }

    function decide() {
      if (state.usage === 'consult') return { primary: 'consult', alt: '' };
      if (state.concern === 'homemade') {
        if (state.freezer === 'no') return { primary: 'fd', alt: 'dry' };
        return { primary: 'frozen', alt: 'fd' };
      }
      if (state.usage === 'add' || state.usage === 'small') return { primary: 'fd', alt: 'frozen' };
      if (state.concern === 'fat' || state.concern === 'senior') return { primary: 'dry', alt: 'fd' };
      return { primary: 'fd', alt: 'frozen' };
    }

    function showStep(name) {
      root.querySelectorAll('[data-hmg-step]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-hmg-step') === name);
      });
      var progress = root.querySelector('[data-hmg-progress]');
      var steps = neededSteps();
      if (name === 'result') {
        progress.hidden = true;
      } else {
        progress.hidden = false;
        var idx = steps.indexOf(name);
        var pct = ((idx + 1) / (steps.length + 1)) * 100;
        root.querySelector('[data-hmg-fill]').style.width = pct + '%';
        root.querySelector('[data-hmg-count]').textContent = (idx + 1) + ' / ' + steps.length;
      }
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function nextFrom(current) {
      var idx = STEP_ORDER.indexOf(current);
      for (var i = idx + 1; i < STEP_ORDER.length; i++) {
        if (isStepNeeded(STEP_ORDER[i])) return STEP_ORDER[i];
      }
      return 'result';
    }

    function sendLog(extra) {
      var logUrl = root.getAttribute('data-hmg-log-url');
      if (!logUrl) return;
      var body = {
        result: lastResult ? lastResult.primary : '',
        age: state.age,
        concern: state.concern,
        usage: state.usage,
        freezer: state.freezer,
        page_url: window.location.href,
        session_id: sessionId
      };
      for (var k in extra) { body[k] = extra[k]; }
      try {
        fetch(logUrl, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify(body)
        });
      } catch (err) {
        // 送信失敗時は何もしない。回答結果の表示自体は継続する
      }
    }

    function renderResult() {
      var r = decide();
      lastResult = r;

      function withDiagParams(url) {
        if (!url || url === '#') return url;
        var qp = new URLSearchParams();
        qp.set('diag_result', r.primary);
        if (state.age) qp.set('diag_age', state.age);
        if (state.concern) qp.set('diag_concern', state.concern);
        if (state.usage) qp.set('diag_usage', state.usage);
        if (state.freezer) qp.set('diag_freezer', state.freezer);
        var sep = url.indexOf('?') === -1 ? '?' : '&';
        return url + sep + qp.toString();
      }

      root.querySelector('[data-hmg-result-title]').textContent = TITLES[r.primary] || '';
      root.querySelectorAll('[data-hmg-card]').forEach(function (card) {
        var isShown = card.getAttribute('data-hmg-card') === r.primary;
        card.hidden = !isShown;
        if (isShown) {
          var cta = card.querySelector('[data-hmg-cta]');
          if (cta) cta.setAttribute('href', withDiagParams(card.getAttribute('data-hmg-url')));
          var crosslink = card.querySelector('[data-hmg-crosslink]');
          if (crosslink) {
            var crossUrl = crosslink.getAttribute('data-hmg-crosslink-url');
            if (crossUrl) crosslink.setAttribute('href', withDiagParams(crossUrl));
          }
        }
      });
      var guardEl = root.querySelector('[data-hmg-guard]');
      var guards = [];
      if (state.age === 'puppy') guards.push(GUARD.puppy);
      if (state.age === 'senior') guards.push(GUARD.senior);
      if (state.concern === 'homemade' && state.freezer === 'no') guards.push(GUARD.freezer);
      if (guards.length) { guardEl.textContent = guards.join(' '); guardEl.hidden = false; }
      else { guardEl.hidden = true; }

      var altEl = root.querySelector('[data-hmg-alt]');
      var altCard = r.alt ? root.querySelector('[data-hmg-card="' + r.alt + '"]') : null;
      if (altCard) {
        root.querySelector('[data-hmg-alt-name]').textContent = altCard.getAttribute('data-hmg-name') || '';
        root.querySelector('[data-hmg-alt-desc]').textContent = altCard.getAttribute('data-hmg-short') || '';
        root.querySelector('[data-hmg-alt-link]').setAttribute('href', withDiagParams(altCard.getAttribute('data-hmg-url')) || '#');
        altEl.hidden = false;
      } else { altEl.hidden = true; }

      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'meal_guide_result', result: r.primary,
          age: state.age, concern: state.concern, usage: state.usage, freezer: state.freezer
        });
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'meal_guide_result', {
          result: r.primary,
          age: state.age,
          concern: state.concern,
          usage: state.usage,
          freezer: state.freezer
        });
      }

      sendLog({});

      showStep('result');
    }

    root.querySelectorAll('[data-hmg-set]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-hmg-set');
        var current = btn.closest('[data-hmg-step]').getAttribute('data-hmg-step');
        state[key] = btn.getAttribute('data-hmg-value');
        btn.closest('.hmg__options').querySelectorAll('.hmg__opt').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        history.push(current);
        var next = nextFrom(current);
        if (next === 'result') renderResult(); else showStep(next);
      });
    });

    root.querySelectorAll('[data-hmg-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var prev = history.pop();
        if (prev) showStep(prev);
      });
    });

    root.querySelectorAll('[data-hmg-switch]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-hmg-switch]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        var ans = root.querySelector('[data-hmg-switch-answer]');
        ans.textContent = SWITCH_TEXT[btn.getAttribute('data-hmg-switch')] || '';
        ans.hidden = false;
        sendLog({ current_food: btn.getAttribute('data-hmg-switch') });
      });
    });

    var restart = root.querySelector('[data-hmg-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        state = { age: '', concern: '', usage: '', freezer: '' };
        history = [];
        root.querySelectorAll('.hmg__opt, .hmg__switch-opt').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        root.querySelector('[data-hmg-switch-answer]').hidden = true;
        showStep('age');
      });
    }

    showStep('age');
  });
})();
